/*
Replace
screenChapter with your resource Name :) Take care about different writings!
/!\ ScreenChapter screenChapter ScreenChapters screenChapters /!\
Keep an eye on pluralized namings in here :)

*/

import { createSlice, createSelector } from "@reduxjs/toolkit";
import {
  defaultList,
  defaultListFail,
  defaultListSuccess,
  defaultShow,
  defaultShowFail,
  defaultShowSuccess,
  defaultUpdate,
  defaultUpdateSuccess,
  defaultUpdateFail,
  defaultCreate,
  defaultCreateSuccess,
  defaultCreateFail,
  defaultAddToDictionary,
} from "../defaultReducers";
import { defaultInitialState } from "../defaultInitialState";

export const screenChapterSlice = createSlice({
  name: "screenChapters",
  initialState: { ...defaultInitialState },
  reducers: {
    list: defaultList,
    listSuccess: defaultListSuccess,
    listFail: defaultListFail,
    show: defaultShow,
    showSuccess: defaultShowSuccess,
    showFail: defaultShowFail,
    create: defaultCreate,
    createSuccess: defaultCreateSuccess,
    createFail: defaultCreateFail,
    update: defaultUpdate,
    updateSuccess: defaultUpdateSuccess,
    updateFail: defaultUpdateFail,
    addToDictionary: defaultAddToDictionary,
  },
});

export const {
  list: listScreenChapterChapters,
  show: showScreenChapter,
  create: createScreenChapter,
  update: updateScreenChapter,
} = screenChapterSlice.actions;

export const actions = screenChapterSlice.actions;
// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const screenChapters = (state) =>
  state.screenChapters.idsList.map((id) => state.screenChapters.dictionary[id]);
export const screenChapter = (state) =>
  state.screenChapters.showId &&
  state.screenChapters.dictionary[state.screenChapters.showId];
export const screenChapterAttributes = (state) =>
  screenChapter(state)?.attributes;
export const screenChapterRelationships = (state) =>
  screenChapter(state)?.relationships;
export const screenChapterId = (state) => state.screenChapters.showId;

export const getScreenChapter = createSelector(
  (state) => state.screenChapters.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id];
  }
);

export const getScreenChapterAttributes = createSelector(
  (state) => state.screenChapters.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.attributes;
  }
);

export const getScreenChapterRelationships = createSelector(
  (state) => state.screenChapters.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.relationships;
  }
);

export const getScreenChapters = createSelector(
  (state) => state.screenChapters.dictionary,
  (_, ids) => ids,
  (dictionary, ids) => {
    return ids && dictionary && ids.map((id) => dictionary[id]);
  }
);

export default screenChapterSlice.reducer;
